var Price_Calculator = {
    init:function(){
        $(".add__to__cart--container .quantity__current").on("change", function(){
            Price_Calculator.calculatePrice();
        });

        $('body').on('DOMNodeInserted', "#product-price", function(){
            Price_Calculator.calculatePrice();
        });
    },
    calculatePrice:function(){
        console.log("_______________________________");
        console.log("Calculate price : " + $("#product-price").html());

        $("button.add__to__cart").find(".calculated-price").remove();

        var _price = parseFloat($("#product-price").html().split(",").join(".")) * 100;
        var _quantity = parseFloat( $(".add__to__cart--container .quantity__current").val());
        var _new_price = Math.round(_price * _quantity) / 100;
        console.log("_new price : " + _new_price);

        $("#product-price").addClass("calculated");

        if(_new_price % 1 != 0){
            _new_price = _new_price.toFixed(2);
        }


        $("#product__top--container button.add__to__cart").append("<span class='calculated-price'>" + _new_price + "€</span>");
        var _spPrice = Math.round((_new_price / 3)*100)/100;


        if(_spPrice%1 != 0 && (_spPrice * 100)%10 == 0){
            _spPrice += "0";
        }
        $(".product__description--fiche .scalapayWidget").find("span").html("€ " +_spPrice);
    }
}

$(window).on("load", function(){
    if($(".akrolab-template #product__top--container").length){
        Price_Calculator.init();
    }
})